angular.module('resourceCenterModule').service('resourceApiService', [
    'trsHttpService',
    '$q',
    function(trsHttpService, $q) {
        let commonParams = {};
        return {
            getAreaParams: getAreaParams, // 获取地域信息的参数
            getArea: requestData, // 获取地域信息
        };

        /**
         * [getAreaParams 获取地域的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getAreaParams() {
            return {
                serviceid: 'navigation',
                typeid: 'zyzx',
                modelid: 'base',
                typeName: 'area',
                containParent: 'false',
                level: '1',
                channelName: '-1',
                parentId: '',
                excludeId: '-1',
            };
        }


        /**
         * [dealParams 公共的参数适配方法]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function dealParams(params){
            return params;
        }
        
        /**
         * [dealData 适配响应数据]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function dealData(data){
            return data;
        }

        /**
         * [requestData 统一的请求方法，默认请求方法]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function requestData(params){
            let deffer = $q.defer();
            let requestParams = angular.extend({}, commonParams, dealParams(params));
            let dataSource = requestParams.dataSource ? requestParams.dataSource : 'bigData';
            let httpMethod = requestParams.httpMethod ? requestParams.httpMethod : 'post';
            if (requestParams.dataSource){
                delete requestParams.dataSource;
            }
            if (requestParams.httpMethod) {
                delete requestParams.httpMethod;
            }
            let url = dataSource === 'bigData' ? trsHttpService.getBigDataRootUrl() : trsHttpService.getWCMRootUrl()
            trsHttpService.httpServer(url, requestParams, httpMethod).then(function(data){
                let result = dealData(data);
                deffer.resolve(result);
            }, function(data){
                deffer.reject(data);
            });
            return deffer.promise;
        }

    },
]);
